<template>
  <div class="inventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader :pageHeader="listPageHeader" :links="[
        { name: 'home', label: 'Home' },
        { name: 'menu', label: ' Menu' },
      ]" :entity="entity" :hideAddButton="true">
        <BaseBtn @click="() => clearCache()" :isLoading="loadingStatus.isClearingStoreCache">
          Clear Store Menu Cache
        </BaseBtn>
        <BaseBtn @click="() => showPreview = !showPreview">
          Preview Menu
        </BaseBtn>
        <BaseBtn @click="() => showPriorityPopUp = !showPriorityPopUp">
          Set Priority
        </BaseBtn>
      </PageHeader>
      <SearchTable :entity="entity" :layoutEntity="layoutEntity" :sort="sort" @sortChangeEvent="updateSort"
        :filterButtons="filterButtons" @filterButtonsChange="updateFilterButtons" :enableAdditionalFilter="true"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" :selectable="true" @itemsSelected="(items) => itemsSelected = items" :clearSelected="clearSelected">
        <div style="display: flex; gap: .5rem;">
          <inline-button
              :type="entity == entities.SUPPLIER ? 'primary' : 'plain-primary'"
              @click="selectSupplierEntity"
              >Suppliers</inline-button>
            <inline-button
              :type="entity == entities.PRODUCT ? 'primary' : 'plain-primary'"
              @click="selectProductEntity"
              >Products</inline-button>
            <inline-button
              :type="entity == entities.FLIGHT ? 'primary' : 'plain-primary'"
              @click="selectFlightEntity"
              >Bundles</inline-button>
        </div>
      </SearchTable>
    </div>
    <BaseModal v-if="showPriorityPopUp" @toggle-modal="showPriorityPopUp = false" :title="`Set ${getSortPriorityTitle} Priority`">
      <SortPriority :itemsSelected="itemsSelected" @setPriority="(e) => setPriority(e)"
        :isLoading="loadingStatus.setPriority"></SortPriority>
    </BaseModal>
    <BaseModal v-if="showPreview" @toggle-modal="showPreview = false" title="Preview Online Menu">
      <ViewOnlineStore></ViewOnlineStore>
    </BaseModal>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";
import BaseBtn from "@/components/Base/Button/Button.vue";
import BaseModal from "@/components/Modals/BaseModal/BaseModal.vue";
import SortPriority from "@/components/SortPriority/SortPriority.vue";
import ViewOnlineStore from "@/components/ViewOnlineStore/ViewOnlineStore.vue";

export default {
  name: "menu",
  data() {
    return {
      listPageHeader,
      entity: Entities.SUPPLIER,
      layoutEntity: Entities.MenuSupplier,
      itemsSelected: [],
      clearSelected: 0,
      showPriorityPopUp: false,
      showPreview: false,
    };
  },
  components: {
    PageHeader,
    SearchTable,
    BaseBtn,
    BaseModal,
    SortPriority,
    ViewOnlineStore,
  },
  created: function () {
    this.setPageTitle("Menu");
  },
  computed: {
    ...mapGetters({
      sort: "menuModule/sort",
      pagination: "menuModule/pagination",
      initialFilter: "menuModule/initialFilter",
      filterButtons: "menuModule/filterButtons",
      loadingStatus: "menuModule/loadingStatus",
    }),
    entities: () => Entities,
    getSortPriorityTitle(){
      switch(this.entity){
        case Entities.PRODUCT:
          return "Product";
      case Entities.SUPPLIER:
        return "Supplier";
      case Entities.FLIGHT:
        return "Bundle";
      default:
        return "Sort";
      }
    }
  },
  methods: {
    ...mapActions({
      setMessage: "setMessage",
      updateSort: "menuModule/updateSort",
      updatePagination: "menuModule/updatePagination",
      updateInitialFilter: "menuModule/updateInitialFilter",
      updateFilterButtons: "menuModule/updateFilterButtons",
      setProductPriority: "menuModule/setProductPriority",
      setSupplierPriority: "menuModule/setSupplierPriority",
      setFlightPriority: "menuModule/setFlightPriority",
      setRefetchTableData: "stateModule/setRefetchTableData",
      clearStoreMenuCache: "menuModule/clearStoreMenuCache",
    }),
    setPriority(e){
      switch(this.entity){
        case Entities.PRODUCT:
          this.setProduct(e);
          break;
        case Entities.SUPPLIER:
          this.setSupplier(e);
          break;
        case Entities.FLIGHT:
          this.setFlight(e);
          break;
      }
    },
    setProduct(e) {
      this.setProductPriority({
        positiveCallback: (result) => {
          this.showPriorityPopUp = false;
          this.clearSelected = Math.random();
          this.setRefetchTableData({clearPagination: true});
        },
        negativeCallback: (error) => {
          console.log(error);
        },
        items: this.itemsSelected,
        sortPriority: Number(e.sortPriority),
        resetPriority: e.resetPriority ?? false,
      });
    },
    setSupplier(e){
      this.setSupplierPriority({
        positiveCallback: (result) => {
          this.showPriorityPopUp = false;
          this.clearSelected = Math.random();
          this.setRefetchTableData({clearPagination: true});
        },
        negativeCallback: (error) => {
          console.log(error);
        },
        items: this.itemsSelected,
        sortPriority: Number(e.sortPriority),
        resetPriority: e.resetPriority ?? false,
      });
    },
    setFlight(e){
      this.setFlightPriority({
        positiveCallback: (result) => {
          this.showPriorityPopUp = false;
          this.clearSelected = Math.random();
          this.setRefetchTableData({clearPagination: true});
        },
        items: this.itemsSelected,
        sortPriority: Number(e.sortPriority),
        resetPriority: e.resetPriority ?? false,
      });
      this.setRefetchTableData({clearPagination: true});
    },
    selectProductEntity(){
      this.clearSelected = Math.random();
      this.entity = Entities.PRODUCT;
      this.layoutEntity = Entities.MENU;
      this.setRefetchTableData({clearPagination: true, entityChanged: true});
    },
    selectSupplierEntity(){
      this.clearSelected = Math.random();
      this.entity = Entities.SUPPLIER;
      this.layoutEntity = Entities.MenuSupplier;
      this.setRefetchTableData({clearPagination: true, entityChanged: true});
    },
    selectFlightEntity(){
      this.clearSelected = Math.random();
      this.entity = Entities.FLIGHT;
      this.layoutEntity = Entities.MenuFlight;
      this.setRefetchTableData({clearPagination: true, entityChanged: true});
    },
    clearCache(){
      this.clearStoreMenuCache({
        positiveCallback: (result) => {
          this.setMessage({
            text: "Menu cache cleared successfully - changes may take up to a minute to take effect.",
            type: "success",
          });
        },
      });
    },
  }
};
</script>
